/* React */
import React from "react";

/* Stylesheet */
import styles from "./ColorLabel.module.scss";

/* Interfaces */
interface ColorLabelProps {
  color?: string;
}

const ColorLabel: React.FC<ColorLabelProps> = ({
  color,
}) => {
  return (
    <div
      style={{ backgroundColor: color }}
      className={styles.color_label}
    />
  );
};

export default ColorLabel;
